import { useEffect, useState } from "react";

export function useDebounce(value: string, delay: number, callback?: (value: string) => void) {
	const [debouncedValue, setDebouncedValue] = useState(value);

	useEffect(() => {
		if (value === debouncedValue) {
			return;
		}

		const handler = setTimeout(() => {
			setDebouncedValue(value);
			callback?.(value);
		}, delay);

		return () => {
			clearTimeout(handler);
		};
	}, [value, delay, callback]);

	return debouncedValue;
}
